import { useTranslation } from "next-i18next";
import { cn } from "../../../../lib/utils";
import { Button } from "../components/Button";
import { Line } from "../components/Line";
import { Subtitle } from "../components/Subtitle";
import { Text } from "../components/Text";

export default function RpaSection() {
	const { t } = useTranslation();

	return (
		<section className="bg-neutral-08">
			<div
				className={cn(
					"container-blog flex bg-no-repeat bg-contain px-20 py-10 h-[570px] laptop:h-auto",
					[
						"laptop:bg-[url(/landings/assets/images/casos/assets/discovery-rpa.svg)] laptop:bg-left",
					],
					[
						"bg-[url(/landings/assets/images/casos/assets/discovery-rpa-mobile.svg)] bg-bottom",
					],
				)}
			>
				<div className="laptop:ml-auto laptop:mr-0 mx-auto w-full max-w-[628px] flex items-center flex-col">
					<Line className="border-vivid-04" />
					<Subtitle>
						<h3 className="text-center">{t("rpa.title")}</h3>
					</Subtitle>

					<Text className="text-center max-w-[588px]">
						{t("rpa.description.part1")}
						<br className="laptop:hidden" />
						{t("rpa.description.part2")}
					</Text>

					<Button
						as="a"
						href="https://calculadora.verzel.com.br/"
						target="_blank"
						rel="noopener noreferrer"
						className="mt-10 text-neutral-08 bg-vivid-04"
					>
						{t("rpa.button")}
					</Button>
				</div>
			</div>
		</section>
	);
}
